import Organization from 'src/components/Organization/pages/Organization';

export default Organization;
